// extracted by mini-css-extract-plugin
export default {"title":"InformationAbout_title__PoNgy","mainContainer":"InformationAbout_mainContainer__F-iqB","fontSize":"InformationAbout_fontSize__XWQaR"};